import { supabase } from '@/integrations/supabase/client';

export interface GifData {
  id: string;
  title: string;
  url: string;
  preview: string;
}

export const giphyService = async (query: string): Promise<{ gifs: GifData[] }> => {
  try {
    const { data, error } = await supabase.functions.invoke('runAgent', {
      body: { agent: 'giphy', query }
    });
    
    if (error) {
      throw new Error(error.message);
    }
    
    return data;
  } catch (error) {
    throw error;
  }
};

export const formatGiphyResponse = (
  data: { gifs: GifData[] },
  searchTerm: string,
  _isDarkMode: boolean = false
): string => {
  // Return a structured JSON payload that ChatMessage.tsx will detect and render via <GiphyResults />
  const payload = {
    __giphy: true,
    // Persist only URLs to storage. UI will derive display titles without persisting them.
    gifs: (data?.gifs || []).map(g => ({ url: g.url })),
    query: searchTerm
  };
  return JSON.stringify(payload);
};
